// extracted by mini-css-extract-plugin
export default {"resultContent":"resultContent__UXl_OR"};